import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SessionServerSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../app/utils/ConnectUtils';
import { addContentFavorite, removeContentFavorite } from '../../actions/FavoritesActions';
import { NavLocationSelectors } from '../../selectors/NavigationStateSelectors';
import { ListView, ListViewDispatchProps, ListViewOwnProps, ListViewStateProps } from './ListView';

const mapStateToProps: MapStateToProps<ListViewStateProps> = (state: AppState) => ({
  displaySchedulesInClientTimezone: SessionServerSelectors.displaySchedulesInClientTimezone(state),
  ignoreExtractTaskPriority: SessionServerSelectors.ignoreExtractTaskPriority(state),
  displayScheduleDescriptionAsName: SessionServerSelectors.displayScheduleDescriptionAsName(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  flowFailureThresholdForRunPrevention: getFlowFailureThresholdForRunPrevention(state),
});

function getFlowFailureThresholdForRunPrevention(state: AppState): number {
  const flowFailureThresholdForRunPrevention = SessionServerSelectors.flowFailureThresholdForRunPrevention(state);
  if (flowFailureThresholdForRunPrevention && flowFailureThresholdForRunPrevention > 0) {
    return flowFailureThresholdForRunPrevention;
  } else {
    return -1;
  }
}

const mapDispatchToProps: MapDispatchToProps<ListViewDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
}, dispatch);

export const ConnectedListView: React.ComponentClass<ListViewOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(ListView);
